import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../../shared";

@Injectable()
export class AddRedeemPointService {
	constructor(private httpclientService: HttpclientService) {}

	PointsItemGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "attendance/PointsItemGetList?categoryTypeID=2&schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	TransactionInsert(points) {
		var postResult$ = new Subject();
		//var url = "attendance/TransactionInsert?PointsItemID=" + points.PointsItemID + "&PointsItemValue=" + points.PointsItemValue + "&PointsTransactionTypeID=" + points.PointsTransactionTypeID + "&SchoolID=" + points.SchoolID + "&PersonID=" + points.PersonID;
		var url = "attendance/TransactionInsert";
		var list = [
			{
				PointsItemID: points.PointsItemID,
				PointsItemValue: points.PointsItemValue,
				PointsTransactionTypeID: points.PointsTransactionTypeID,
				SchoolID: points.SchoolID,
				PersonID: points.PersonID,
			},
		];

		var promise$ = this.httpclientService.post(url, list);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
